import * as React from 'react';
import * as s from './InputField.module.scss';
import Text from '../Text';

interface State {
  isFocused: boolean;
}

interface Props {
  type: string;
  name: string;
  label?: string;
  placeholder?: string;
  onChange: Function;
  value: string;
  required: boolean;
  pattern?: string;
  fullWidth?: boolean;
  mTop?: boolean;
  dark?: boolean;
  customBootstrap?: string;
  backgroundWhite?: boolean;
  className?: string;
}

class InputField extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isFocused: false,
    };
  }

  render() {
    const { isFocused } = this.state;
    const {
      type,
      name,
      label,
      placeholder,
      onChange,
      value,
      required,
      pattern,
      fullWidth,
      mTop,
      dark,
      backgroundWhite,
      customBootstrap,
      className,
    } = this.props;

    const InputClasses = [];
    mTop && InputClasses.push(s.mTop);
    dark && InputClasses.push(s.dark);

    const wrapperBootstrap =
      customBootstrap && customBootstrap.length > 0
        ? customBootstrap
        : 'col-12 ' + (fullWidth ? 'col-md-12' : 'col-md-6');

    return (
      <div
        className={`${wrapperBootstrap} ${s.wrapper} ${
          isFocused || value.length > 0 ? s.focus : ''
        } ${backgroundWhite ? s.backgroundWhite : ''} ${
          className ? className : ''
        }`}
      >
        {label && <Text h6>{label}</Text>}
        <input
          className={InputClasses.join(' ')}
          type={type}
          name={name}
          placeholder={placeholder ? placeholder : ''}
          pattern={pattern}
          onChange={e => onChange(e)}
          onFocus={() => this.setState({ isFocused: true })}
          onBlur={() => this.setState({ isFocused: false })}
          value={value}
          required={required}
        />
      </div>
    );
  }
}

export default InputField;
